import { CELL_RANGE_REGEX, cellAdressRegex } from '../../constants/regex';
import { columnLetterToIndex } from '../../utils/area/area';
import { Area } from './area';

export enum AddressType {
  Column = 'C',
  Row = 'R',
  Range = 'Ra',
  Position = 'P',
}

export interface AbsoluteAreaFlags {
  start: {
    col: boolean;
    row: boolean;
  };
  end: {
    col: boolean;
    row: boolean;
  };
}

export interface AbsoluteRangeFlags {
  start: boolean;
  end: boolean;
}
